module.exports = __webpack_public_path__ + "static/client1-79db2d74d85b3e246e14f6ec67bc7b7a.png";